import React, { useEffect } from 'react';
import { authTokenService } from '../api/api';
import { useAuth } from '../auth/auth_context';
import { useNavigate } from 'react-router-dom';
import Audit from '../utils/audit_util';

function AuthCallback() {
    const { setToken, setIsAuthReady } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthentication = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const authCode = urlParams.get('code');
            try {
                const data = await authTokenService.fetchToken(authCode);
                if (data && data.token && data.token.id_token) {
                    document.cookie = `sid=${data.token.id_token}; path=/`;
                    setToken(data.token.id_token);
                    setIsAuthReady(true);
                    Audit.LogUserAction('login.completed', 'login', 'success');
                    navigate('/home');
                } else {
                    console.error('Invalid token structure:', data);
                    navigate('/login');
                }
            } catch (error) {
                console.error('Authentication error:', error);
                navigate('/login');
            }
        };
        handleAuthentication();
    }, [setToken, setIsAuthReady, navigate]); 

    return (
        <div>
            Processing authentication...
        </div>
    );
}

export default AuthCallback;
